import React, { PropsWithChildren } from 'react';

import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

import { env } from '@/config/env';

import { RoutesEnum } from '@/enums/routes.enum';

import { useSettings } from '@/hooks/useSettings.hook';

export const GlobalBackground: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;

  const { pathname } = useLocation();
  const { isMobile } = useSettings();
  const isHowToPlayPage = pathname === RoutesEnum.guide;

  // BG images provided by the admin
  const mobileMainBg = `${env.BANNER_BASE_URL}/global-bg_mobile.png`;
  const desktopMainBg = `${env.BANNER_BASE_URL}/global-bg_desktop.png`;
  const desktopHowToPlayBg = `${env.BANNER_BASE_URL}/how-to-play-bg_desktop.png`;
  const mobileHowToPlayBg = `${env.BANNER_BASE_URL}/how-to-play-bg_mobile.png`;

  const drawBg = () => {
    if (isHowToPlayPage) {
      return isMobile ? mobileHowToPlayBg : desktopHowToPlayBg;
    }
    return isMobile ? mobileMainBg : desktopMainBg;
  };

  return (
    <Box
      backgroundAttachment='fixed'
      backgroundImage={drawBg()}
      backgroundPosition='center'
      backgroundRepeat='no-repeat'
      backgroundSize='cover'
      height='auto'
      minHeight='700px'
      width='100%'
    >
      {children}
    </Box>
  );
};
